import { Label } from './label'

export type Dataset = {
  id: string
  name: string
  description: string
  labels: Label[]
  labeling_type: LabelingType
  labeling_type_display: string
  dataset_type: DatasetType
  dataset_type_display: string
  is_library: boolean
  media_files_count: number
  version_files_count: number
  size_mb: number
  thumbnail: string | null
  created_at: string
  updated_at: string
}

export enum DatasetType {
  Primary = 1,
  Secondary = 2
}

export enum LabelingType {
  ObjectDetection = 1,
  InstanceSegmentation = 2,
  SemanticSegmentation = 3,
  Classification = 4
}

export type DatasetVersion = {
  id: string
  dataset: string
  version: number
  status: DatasetVersionStatus
  status_display: string
  parent_version: Omit<DatasetVersion, 'parent_version' | 'labels'> | null
  labels: Label[]
  created_at: string
  updated_at: string
}

export enum DatasetVersionStatus {
  Draft = 1,
  Completed = 2
}

export type FileMetadata = {
  id: string
  name: string
  status: FileStatus
  status_display: string
  dataset: number
  media_file: string
  thumbnail: string
  media_type: MediaType
  extension: string
  created_at: string
  updated_at: string
  original_video_fps: number | null
  annotation_id: string | null
}

export enum FileStatus {
  Unlabeled = 1,
  Labeled = 2
}

type MediaType = 'image' | 'video'

export type UploadStatus = {
  status: 'Pending' | 'Complete' | 'Failed'
  total_files: number
  uploaded_files: number
  failed_files: number
  failed_file_names: string[]
}
